module.exports = __webpack_public_path__ + "static/img/WechatIMG140.dc825a3a.png";